<template lang="pug">
  #app(ref="app")
    svg-sprite

    a-scene.root-scene(
      ref="scene"
      embedded
      vr-mode-ui="enabled: false"
      background="transparent: true;"
      texture-cache
      anim-fov="80"
      preserveDrawingBuffer="true"
      effects="camdistortion, sharpen"
      :camdistortion="`active: ${welcomeShot.finished}; strength: ${3.4+0.15*welcomeTl3*camZoom}; center: 0.5 0.5;`"
      :sharpen="`active: ${true}; strength: ${0.6}; center: 0.5 0.5;`"
    )
      //effects="camdistortion, sharpen, filmgrain"
      //:sharpen="`active: ${true}; strength: ${0.2}; center: 0.5 0.5;`"
      //:filmgrain="`active: ${true}; strength: ${20}; center: 0.5 0.5;`"
      //:film="`speed: 1.0; nIntensity: 0.05; sIntensity: 0.8; sCount: 4096;`"
      aframe-loader(
        id="app"
        :assets="assets"
        :minTime="0"
      )
      //- CAMERA
      a-entity.pivot(
        ref="pivot"
        position="0 0 0"
        rotation="0 0 0"
      )
        a-camera.camera(
          ref="camera"
          :position="`${welcomeShot.x*welcomeTl2*welcomeReady} ${welcomeShot.y*welcomeTl1*welcomeReady} ${distanceForPerfectProjection-welcomeShot.z*welcomeTl2*welcomeReady}`"
          look-controls-enabled="false"
          cursor="rayOrigin: mouse"
          raycaster="interval: 100; objects: .clickable; recursive: true;"
          :gyro-position="`active:${enableCamGyro}; delay: 0.05; multiplier: ${gyroMultiply}; limit: 0 0`"
        )
        a-plane(
          v-if="!welcomeShot.finished"
          id="a-pattern"
          :position="`${-100*welcomeReady} ${welcomeReady*100} 0`"
          :geometry="`width: ${windowWidth}; height: ${windowHeight};`"
          :width="windowWidth"
          :height="windowHeight"
          :pattern="`tex: #pattern; speed: 1; mask: ${welcomeTl0}; progress: ${tutorProgress}; spd: ${slideOnTouch? 1: 0.1}; touch: ${tutorTouchX} ${tutorTouchY};`"
        )

      router-view

    audio-player(v-if="loading.completed")
    mode-switch(v-if="modeSwitching" @complete="modeSwitchComplete" :toMode="toMode")
    landscape-warning

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ResizeService from 'src/services/ResizeService'
import Version from 'src/components/_utils/Version'
import LandscapeWarning from 'src/components/unsupported/LandscapeWarning'
import AframeLoader from 'src/components/AframeLoader'
import Gyro from 'src/helpers/Gyro'
import * as MODES from 'src/config/modes'
import getDistanceForPerfectProjection from 'src/aframe/utils/getDistanceForPerfectProjection'
import assets from './assets'
import SvgSprite from 'src/components/vca/widgets/SvgSprite'
import ModeSwitch from 'src/components/vca/widgets/ModeSwitch2'
import AudioPlayer from 'src/components/vca/widgets/AudioPlayer'
import BgPattern from "src/components/vca/widgets/BgPattern"
import {TimelineMax, Sine, TweenMax, Circ, Power2} from 'gsap'


export default {
  name: 'app',
  components: {
    BgPattern,
    LandscapeWarning,
    Version,
    AframeLoader,
    SvgSprite,
    ModeSwitch,
    AudioPlayer,
    //GyroView
  },
  data() {
    return {
      assets: assets,
      accGap: false,
      lastAccY: 0,
      vY: 0,
      disY: 0,
      timestamp: 0,

      welcomeShot: {
        default:{
          x: -120,
          y: 230,
          z: 230,
        },
        x: -120,
        y: 230,
        z: 230,
        finished: false
      },
      welcomeReady: 0,
      welcomeTl0: 0,
      welcomeTl1: 1,
      welcomeTl2: 1,
      welcomeTl3: 0,
      //tutorProgress: 0,
      toMode: null,
      enableCamGyro: false,
      slideOnTouch: false,

      slideTouch: [window.innerWidth, window.innerHeight],
      slideTouchX: 0.5,
      slideTouchY: 1
    }
  },
  computed: {
    gyroMultiply(){
      if (this.isAndroid)
        return 8
      else
        return 0.5
    },
    distanceForPerfectProjection() {

      let fov = 80
      return getDistanceForPerfectProjection(fov, this.windowHeight)

    },
    ...mapState('browser', ['isMobile', 'windowHeight', 'windowWidth', 'isAndroid', 'isIphoneX']),
    ...mapState('app', ['mode', 'loading', 'loadAframe', 'loadScene', 'camZoom', 'camDistort', 'sceneEntered', 'modeSwitching', 'modeLock', 'tutorProgress',
      'tutorTouchX', 'tutorTouchY']),
    bgHeight() {
      return (this.windowHeight+100)
    },
    bgWidth() {
      let ratio = 1535 / 1024
      return this.bgHeight * ratio
    },

  },
  beforeMount() {
    // listen to resize service and update the store with changes
    ResizeService.on(ResizeService.Events.RESIZE, this.resize)
    this.resize()
  },
  mounted() {
    window.App = this



    window.addEventListener('contextmenu', (e) => {
      e.preventDefault()
    })
    Gyro.on(Gyro.Events.UPDATE, this._onGyroUpdate)

    window.addEventListener('keyup', () => {
      if (!this.modeSwitching && !this.modeLock){
        this.lockMode()
        this.setModeSwitching(true)
      }
    })

    this.resize()


  },

  beforeDestroy() {
    Gyro.off(Gyro.Events.UPDATE, this._onGyroUpdate)
  },
  methods: {
    // prettier-ignore
    ...mapMutations('app', [
      'setMode',
      'setSceneLoadProgress',
      'setModeSwitching',
      'lockMode',
      'unlockMode',
      'toggleMode'
    ]),
    ...mapMutations('browser', [
      'setDevice',
      'setScale',
      'setFontSize',
      'setDimensions'
    ]),



    switchMode(){
      if (!this.modeSwitching && !this.modeLock){
        this.lockMode()
        this.setModeSwitching(true)
      }
    },
    resize() {
      // put these in the store so we don't need to manually
      // listen to ResizeService everytime we want to react to
      // device/scale/size changes
      this.setDevice(ResizeService.device)
      this.setScale(ResizeService.scale)
      this.setFontSize(ResizeService.fontSize)
      this.setDimensions({
        width: ResizeService.width,
        height: ResizeService.height,
      })

      this.resizeRenderer()
      //if(window.innerWidth>window.innerHeight) return
      this.welcomeShot.x = this.welcomeShot.default.x*window.innerWidth/375
      this.welcomeShot.y = this.welcomeShot.default.y*window.innerHeight/812
      this.welcomeShot.z = this.welcomeShot.default.z*window.innerHeight/812

    },

    resizeRenderer() {
      if (this.$refs.scene && this.$refs.scene.renderer) {
        console.log(777, typeof this.$refs.scene, document.querySelector('a-scene'))
        this.$refs.scene.renderer.setSize(window.innerWidth, window.innerHeight)
      }
      //let c = document.querySelector('.a-canvas')
      //console.log(9990009991, this.$refs.scene, c.width, c.height, c.clientWidth, c.clientHeight)
      //this.$refs.scene.renderer.setSize(window.innerWidth*window.devicePixelRatio, window.innerHeight*window.devicePixelRatio)


      //c.width = window.innerWidth*window.devicePixelRatio
      //c.height =  window.innerHeight*window.devicePixelRatio
      //c.style.width = window.innerWidth+'px'
      //c.style.height = window.innerHeight+'px'
      //console.log(999000999, this.$refs.scene.renderer.getPixelRatio(), c.width, c.height)
    },
    camGyroOn(){
      this.enableCamGyro = true
    },
    camGyroOff(){
      this.enableCamGyro = false
    },
    // setTutorProgress(data){
    //   this.tutorProgress = data
    // },
    // setSlideOnTouch(data){
    //   this.slideOnTouch = data
    // },
    // setSlideOnTouchStart(x, y){
    //   console.log(999)
    //   this.slideOnTouch = true
    //   this.slideTouchX = x/window.innerWidth
    //   this.slideTouchY = y/window.innerHeight
    // },
    // setSlideOnTouchEnd(y){
    //   this.slideOnTouch = false
    //   this.slideTouchX = 0.5
    //   this.slideTouchY = y/window.innerHeight
    // },
    // setSlideTouch(x, y){
    //
    //   this.slideTouchX = x/window.innerWidth
    //   this.slideTouchY = y/window.innerHeight
    // },

    welcomeSetup(cb){
      this.welcomeReady = 1
      let tl = new TimelineMax({ onComplete: () => {
          cb()
        }
      })
      this.tl = tl

      tl.add('start')
        .to(
          this,
          1,
          {
            welcomeTl0: 1,
            ease: Power2.easeOut
          },
          `start+=0.5`
        )
    },
    welcomeAni(cb) {
      //let f = this.normalDecay(MathUtils.randomInRange(0, 2),1)
      console.log('welcome')
      let tl = new TimelineMax({ onComplete: () => {
          this.welcomeShot.finished = true
          cb()
          TweenMax.to(this, 2.5, {
            welcomeTl3: 1,
            ease: Circ.easeOut,
            delay: 0
          })
        }
      })
      this.tl = tl

      tl.add('start')
        .to(
          this,
          2,
          {
            welcomeTl1: 0,
            ease: Sine.easeOut
          },
          `start+=0`
        )
        .to(
          this,
          2,
          {
            welcomeTl2: 0,
            ease: Sine.easeInOut
          },
          `start+=1`
        )

    },
    modeSwitchComplete(){
      //this.modeSwitching = false
      this.setModeSwitching(false)
      //this.unlockMode()
      // if (this.toMode !== null){
      //   this.setMode(this.toMode)
      // }
    },
    modeSwitchAni() {
      this.modeSwitching = true

    },
    _onGyroUpdate (evt) {
      //let verticelTest = Math.sqrt(evt.x*evt.x+evt.z*evt.z) < 8

      let verticelTest = Math.abs(evt.gx)+Math.abs(evt.gz) < 12

      if (verticelTest && !this.modeSwitching && !this.modeLock){

        if (this.mode === MODES.ADULTS && evt.y < -4) {
          this.setModeSwitching(true)
          this.lockMode()

          //this.toMode = MODES.KIDS
          //this.modeSwitchAni()
          return
        }
        if (this.mode === MODES.KIDS && evt.y > 4) {
          this.setModeSwitching(true)
          this.lockMode()
          //this.toMode = MODES.ADULTS
          //this.modeSwitchAni()
          return

        }
      }

    },
    onLoadSceneProgress(val){
      this.setSceneLoadProgress(val.progress)
    }
  },
  watch: {
    // slideTouch(val){
    //   console.log(111, val)
    // }
  }
}
</script>

<style lang="sass">
@import "src/styles/base.sass"

#app
  overflow: hidden

#app, .container, .root-scene
  +full()

#app .container a-scene > canvas
  +full()
  width: 100% !important
  height: 100% !important
.a-canvas
  position: absolute
  //z-index: -10
  pointer-events: none

.mode-switch

  +full()
  .upper
    width: 100%
    height: 50%
    background: #3a54a2
    transform: translateY(-100%)
  .bottom
    width: 100%
    height: 50%
    background: crimson
    transform: translateY(100%)




</style>
